import React from "react";
import Sidebar from '../components/SideBar';
import "../styles/SemAcesso.css";
import { Construction } from 'lucide-react';

const SemAcesso: React.FC = () => {
  return (
    <div style={{ display: 'flex', background: '#f5f5f5' }}>
      <Sidebar />
        <div className="sem-acesso-container">
        <Construction size={50} color="#29306a" />
        <h1>Você não possui acesso a esta área</h1>
        <p>Entre em contato com o administrador ou atualize seu plano.</p>
        </div>
    </div>
  );
};

export default SemAcesso;
